import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toAbsoluteUrl } from "../../_helpers";
import axios from "axios";
import { symbol } from "prop-types";
import { NODE_API_URL } from "../../../env_config";
import { useHistory } from "react-router-dom";
import { SwalSuccess ,SwalError } from "./";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Backdrop,CircularProgress,} from "@material-ui/core";
import {OverlayTrigger,Tooltip,Overlay} from "react-bootstrap";
import { FaExternalLinkAlt,FaInfoCircle} from "react-icons/fa";

const perfectScrollbarOptions = {
    wheelSpeed: 1,
    wheelPropagation: false,
};

export const BuyDiamond = (props) => {

    const [showConfirm, setShowConfirm] = useState(false);
    const [swalSuccessOpen,setSwalSuccessOpen] = useState(false)
    const [swalErrorOpen,setSwalErrorOpen] = useState(false)
    const [alertMessage,setAlertMessage] = useState()

    const [loading, setLoading] = React.useState(false);
    const [isSubmitting ,SetIsSubmitting] = useState(false)
    const [openLoader, setOpenLoader] = React.useState(false);

    const enableLoading = () => {
        setLoading(true);
        setOpenLoader(true);
        SetIsSubmitting(true)
    };
    const disableLoading = () => {
        setLoading(false);
        setOpenLoader(false);
        SetIsSubmitting(false)
    };


    const history = useHistory()
    useEffect(() => {
        SetComment(null)
        setShowConfirm(props.show)
    },[props.show])
    const closeModel = () => {
        props.onHide()
        setShowConfirm(false)
    }
    const closeSwal = (props) => {
        // props.onHide()
        setShowConfirm(true)
        setSwalSuccessOpen(false)
    }
    const swalSuccessOpenfn = (props) => {
        closeModel()
        setSwalSuccessOpen(true)
    }
    const swalErrorOpenfn = (props) => {
        closeModel()
        setSwalErrorOpen(true)
    }

    const ConfirmDiamonds = (diamonds) => {
        const userData = JSON.parse(localStorage.getItem("userData"))
        let dianondinfo = diamonds.diamondselected.map(value => {
            return {
                "WLDiamondType": value.diamond_type,
                "user_id": userData.CustomerId,
                "Certi_No": [
                    value.Certi_NO
                ],
                "conform_good_id": value.conform_good_id,
                "customer_comment":comment
            }
        })
        enableLoading()
        axios({
            method: "POST",
            url: `${NODE_API_URL}/TESTMODE/StoneHoldToConfirmMail`,
            headers: { "Content-Type": "application/json" },
            data: dianondinfo,
        }).then(res => {
            disableLoading()
            // window.location.reload(true)
            reDirectToConfirm()
        }).catch(err => {
            disableLoading()
            console.log(err,"ERRRORROS")
        })
    }

    const reDirectToConfirm = () => {
        history.push({
            pathname: `/confirmgoods`
        })
    }
    const [comment,SetComment] = useState("")
    // console.log(comment,"COMMENT")
    function numberWithCommas(x) {
        if(x){
        return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        }
    }
    console.log(props.diamondselected,"props.diamondselected")
    return (
        <div>
            <Modal
                show={showConfirm}
                onHide={props.onHide}
                backdrop="static"
                keyboard={false}
                size="lg"
            >
                <Modal.Header>
                    <Modal.Title>{props.language.CONFIRM_GOODS_POPUP_CONFIRM_DIAMOND}</Modal.Title>
                    <div className="d-flex">
                        {/* <div className="text-primary font-weight-bolder font-size-lg d-flex mr-4">
                            {props.language.CONFIRM_GOODS_POPUP_INR_RATE}: <div className="ml-2">₹{props.diamondselected.length !== 0 ? JSON.stringify(props.diamondselected[0].curr_inr) : null}</div >
                        </div> */}
                        <button type="button" className="close" onClick={() => closeModel(props)}><span aria-hidden="true">×</span><span className="sr-only">Close</span></button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        
                        <div className="col-12 d-flex justify-content-between mb-3">
                            <span>{props.language.CONFIRM_GOODS_POPUP_TOTAL_DIAMONDS} : {props.diamondselected.length}</span>
                            <div>
                                {((props.diamondselected.length) - props.diamondcount ) == 0 ? "":
                                 <div className="d-flex font-weight-bold">
                                    <div className="text-success mr-2">{props.diamondcount} Diamonds are valid</div> 
                                    <div className="text-danger">{((props.diamondselected.length) - props.diamondcount )} Diamonds are not consider in total</div>
                                </div>}
                            </div>
                        </div>
                        <div className="col-12">
                            <PerfectScrollbar
                                options={perfectScrollbarOptions}
                                className="scroll border-bottom"
                                style={{ maxHeight: "322px", position: "relative" }}
                            >
                                <table className="table border-bottom">
                                    <thead>
                                        <tr className="bg-gray-100 sticky-top">
                                            <th className="text-center py-3">{props.language.CONFIRM_GOODS_POPUP_DIAMOND_DETAILS}</th>
                                            <th className="text-center py-3">{props.language.CONFIRM_GOODS_POPUP_DIAMOND_LOCATION} <br/> {props.language.CONFIRM_GOODS_POPUP_DIAMOND_SHIPPING_DAYS}</th>
                                            <th align="center" className="text-right py-3">
                                                {props.language.CONFIRM_GOODS_POPUP_OURPRICEUSD} <br />
                                                USD/CT
                                            </th>
                                            {/* <th align="center" className="text-right py-3">
                                            {props.language.CONFIRM_GOODS_POPUP_OURPRICEINR} <br />
                                                INR/CT
                                            </th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {props.diamondselected.map((value,index) => (
                                        <tr className={`position-relative `}>
                                            <td>
                                                {/* {value.country !== "INDIA"?
                                                    <span className="CanNotHold"> Unfortunately, Diamond location outside India cant be ordered</span>
                                                :""} */}
                                                {/* {value.can_hold === 1 ? "":  <span style={{fontSize:"8px",color:"red"}}> DIAMOND NOT AVAILABLE FOR HOLD</span> } */}
                                                <div className={`row`}>
                                                    <div className="col-2 text-center p-0">
                                                        {value.aws_image ? (
                                                            <img className="img-fluid mr-2" alt={value.C_Shape} src={value.aws_image} width="50px" />
                                                        ) : (
                                                            <img className="img-fluid mr-2" alt={value.C_Shape} src={toAbsoluteUrl(`/media/shape/${value.C_Shape.toLowerCase()}-no.png`)} width="50px" style={{ backgroundColor:"#f4f4f4", }} />
                                                        )}
                                                    </div>
                                                    <div className="col-10 pl-2 p-0">
                                                        <div className="mb-1">
                                                            <span
                                                                className={`${
                                                                    value.diamond_type === "N"
                                                                        ? value.C_Color === "fancy" ? "F" : "W"
                                                                        : value.C_Color === "fancy" ? "LF" : "L"
                                                                }_diamond mr-3 small`}
                                                            >
                                                                {value.diamond_type === "N"
                                                                    ? value.C_Color === "fancy" ? "F" : "W"
                                                                    : value.C_Color === "fancy" ? "LF" : "L" }
                                                            </span>
                                                            <span className="text-primary small">
                                                                {value.Lab}-
                                                                {value.Certi_NO}
                                                            </span>
                                                            <span className="small ml-2">
                                                                {value.diamond_type === "N" ? "N" : "L"}-{value.id}
                                                            </span>
                                                        </div>

                                                        <span className="text-dark font-weight-bold d-block">
                                                            {value.C_Shape}{" "}
                                                            {value.C_Weight}{" "}
                                                            {value.C_Color ===
                                                            "fancy" ? (
                                                                <>
                                                                    {value.f_intensity}{" "}
                                                                    {value.f_overtone}{" "}
                                                                    {value.f_color}{" "}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    {value.C_Color}{" "}
                                                                </>
                                                            )}
                                                            {value.C_Clarity}{" "}
                                                            {value.C_Cut}{" "}
                                                            {value.C_Polish}{" "}
                                                            {value.C_Symmetry}{" "}
                                                            {value.C_Fluorescence}{" "}
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className={`text-center`}>
                                                {value.country} <br />
                                                {value.shippingdays} Days 
                                            </td> 
                                            <td className={`text-right text-primary font-weight-bold `}>
                                               ${numberWithCommas(parseFloat(value["OurPrice(USD)"]))}
                                               {value.show_supplier === 1?<OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip">
                                                           Supplier Price: ${value["calculateprice"]["net_price"]}<br/>
                                                           Our Charges: ${(Math.round(value["calculateprice"]["newcharge"] * 100)/100).toFixed(2)} 
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className="ml-2 text-hover-primary cursor-pointer"><FaInfoCircle /></span>
                                                </OverlayTrigger>:""}<br/>
                                               <span className="text-muted small">USD/CT {numberWithCommas(parseFloat(value["USD/CT"]))}</span >
                                            </td>
                                            {/* <td className={`text-right text-primary font-weight-bold ${value.country !== "INDIA" ? "CanNotHoldDiv" : "" }`}>
                                                ₹{numberWithCommas(parseFloat(value["OurPrice(INR)"]))}<br/>
                                                <span className="text-muted small"> ₹/CT {numberWithCommas(parseFloat(value["INR/CT"]))}</span>
                                            </td> */}
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </PerfectScrollbar>
                            <div className="text-primary font-weight-bold mt-4 font-italic" >{props.diamondselected.length > 4 ? "Scroll for explore all diamonds":""}</div>
                            <div className="row mt-5">
                                <div className="col-12 font-size-h6 text-right font-weight-bold">
                                     USD/CT {props.language.CONFIRM_GOODS_POPUP_PRICE} : ${numberWithCommas(props.totalinrcar)}
                                </div>
                                <div className="col-12 font-size-h6 mt-2 text-right font-weight-bolder">
                                Total USD : ${numberWithCommas(props.totalourprice)}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <Form.Group controlId="Notes">
                                        <Form.Label>
                                            {props.language.CONFIRM_GOODS_POPUP_NOTES}:
                                        </Form.Label>
                                        <Form.Control as="textarea" rows="3" onChange={(e) => SetComment(e.target.value)} maxLength={256} placeholder="Please enter your notes if any"/>
                                    </Form.Group>
                                    <span className="p-2">255 Characters Remaining</span>
                                </div>
                            </div>
                            {/* <pre>{JSON.stringify(props)}</pre> */}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                {props.conversionrate !== 1?<div>
                    All purchase are under USD
                    </div>:""}
                    <Button variant="secondary" className="mr-2 font-weight-bold" onClick={() => closeModel(props)}>
                        {props.language.CONFIRM_GOODS_POPUP_CLOSE}
                    </Button>
                    <Button className="px-8 font-weight-bold" disabled={isSubmitting} variant="primary" onClick={() => ConfirmDiamonds(props)}>
                        {props.language.CONFIRM_GOODS_POPUP_CONFIRM_ORDER}
                        {loading && <span className="ml-1 spinner spinner-white"></span>}
                        <Backdrop
                            sx={{ color: '#002173', zIndex: (theme) => theme.zIndex.drawer + 5 }}
                            open={openLoader}
                            // onClick={handleCloseLoader}
                        >
                            <CircularProgress color="secondary" />
                        </Backdrop>
                    </Button>
                </Modal.Footer>
            </Modal>
            <SwalSuccess show={swalSuccessOpen} message={alertMessage} onClose={() => setSwalSuccessOpen(false)} responseOnOk={reDirectToConfirm}/> 
            <SwalError show={swalErrorOpen} message={alertMessage} onClose={() => setSwalErrorOpen(false)} /> 
        </div>
    );
};
